"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var attensiLoginPlugin_1 = require("./attensiLoginPlugin");
exports.AttensiLoginPlugin = attensiLoginPlugin_1.AttensiLoginPlugin;
function AttensiLogin(Vue, attensiLoginOptions) {
    Vue.prototype.$api = new attensiLoginPlugin_1.AttensiLoginPlugin(attensiLoginOptions);
    Vue.prototype.$portal = Vue.prototype.$api.portal;
    Vue.prototype.$creator = Vue.prototype.$api.creator;
}
exports.AttensiLogin = AttensiLogin;
exports.default = AttensiLogin;
